import React from "react";
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// eslint-disable-next-line space-before-function-paren
export default function ConfirmModal(props) {

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

  return (
    <>
      <BootstrapDialog
        onClose={props.handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {props.header}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.handleCloseModal}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          ¿{props.body}?
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={props.handledConfirmDelete}>
            {props.button}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}
